import { getStoreBuilder, BareActionContext } from 'vuex-typex';
import { RootState } from './index';
import { ProductTabTypeChange } from '@/models/Product';

export interface ProductTabState {
    selectedTabTypeLandscape: ProductTabTypeChange;
    selectedTabTypePortrait: ProductTabTypeChange;
}

const initialState: ProductTabState = {
    selectedTabTypeLandscape: {} as ProductTabTypeChange,
    selectedTabTypePortrait: {} as ProductTabTypeChange
};

const store = getStoreBuilder<RootState>().module('product', initialState);

// private getters
function getStoreSelectedTabTypeLandscape(state: ProductTabState): ProductTabTypeChange {
    return state.selectedTabTypeLandscape;
}
function getStoreSelectedTabTypePortrait(state: ProductTabState): ProductTabTypeChange {
    return state.selectedTabTypePortrait;
}

// getters
const getSelectedTabTypeLandscape = store.read(getStoreSelectedTabTypeLandscape, 'getStoreSelectedTabTypeLandscape');
const getSelectedTabTypePortrait = store.read(getStoreSelectedTabTypePortrait, 'getStoreSelectedTabTypePortrait');

// mutations:
function mutateSelectedTabTypeLandscape(state: ProductTabState, payload: ProductTabTypeChange): Promise<void> {
    return new Promise((resolve, reject) => {
        state.selectedTabTypeLandscape = payload;
        resolve();
    });
}
function mutateSelectedTabTypePortrait(state: ProductTabState, payload: ProductTabTypeChange): Promise<void> {
    return new Promise((resolve, reject) => {
        state.selectedTabTypePortrait = payload;
        resolve();
    });
}

// actions
async function saveSelectedTabTypeLandscape(
    context: BareActionContext<ProductTabState, RootState>,
    payload: ProductTabTypeChange
): Promise<void> {
    return await mutateSelectedTabTypeLandscape(context.state, payload);
}
async function saveSelectedTabTypePortrait(
    context: BareActionContext<ProductTabState, RootState>,
    payload: ProductTabTypeChange
): Promise<void> {
    return await mutateSelectedTabTypePortrait(context.state, payload);
}

// export store
export const ProductTabStore = {
    setSelectedTabTypeLandscape: store.dispatch(saveSelectedTabTypeLandscape, 'saveSelectedTabTypeLandscape'),
    setSelectedTabTypePortrait: store.dispatch(saveSelectedTabTypePortrait, 'saveSelectedTabTypePortrait'),
    get getSelectedTabTypeLandscape() {
        return getSelectedTabTypeLandscape();
    },
    get getSelectedTabTypePortrait() {
        return getSelectedTabTypePortrait();
    }
};
